module.exports = __webpack_public_path__ + "assets/3adc0efcefa79ec1713580303614a73b.svg";